/** Frozen eight-question investigation helper on the finding inspector. */
export const INVESTIGATION_QUESTIONS = [
  "What does the cited code do?",
  "Why could it matter?",
  "What attack path is actually supported?",
  "What evidence would validate or refute the claim?",
  "What uncertainty remains?",
  "What should be fixed first?",
  "What could remediation break?",
  "What is the smallest safe validation step?",
] as const;

export const UNCONFIGURED_MODEL_ASSIST_MESSAGE =
  "Investigation is unavailable because no model provider is configured. The cited evidence is unchanged. This answer is advisory and cannot change the verdict.";
